/**
 * Created by administrator on 2019/3/20.
 */
import axios from 'axios'

const service = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? '/api/' : 'http://47.95.5.207:3000/api/', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  withCredentials: true
  // timeout: 5000 // request timeout
})

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 0) {
      return Promise.reject(res)
    } else {
      return res
    }
  },
  error => {
    return Promise.reject(error)
  }
)

export default service
